export enum VpaProductType {
  VpaPay,
  VpaFlex
}
